import { render, staticRenderFns } from "./ListaVenceHoje.vue?vue&type=template&id=efc57eba&scoped=true&"
import script from "./ListaVenceHoje.vue?vue&type=script&lang=js&"
export * from "./ListaVenceHoje.vue?vue&type=script&lang=js&"
import style0 from "./ListaVenceHoje.vue?vue&type=style&index=0&id=efc57eba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc57eba",
  null
  
)

export default component.exports